import { GridColumnVisibilityModel } from '@mui/x-data-grid-premium'

export const defaultVisibilityModel: GridColumnVisibilityModel = {
  keyTerm: false,
  ggLid: false,
  userId: false,
  sessionId: false,
  pageURL: false,
}
